<template>
    <div class="dashboard-widget-content">
        <template v-if="!value.ShowOptions">
            <chart-card-dashboard-wings no-footer>
                <bar-chart :series="demoSeries()"
                           :style="chartStyle"
                           :xAxis="demoXAxis()"
                           :yAxis="yAxis"
                           tooltip-format="{b}: <b>{a}{c}%</b>"></bar-chart>
            </chart-card-dashboard-wings>
        </template>
        <template v-else>
            <widget-options>
                <md-field>
                    <label>{{ $t('widget.options.update') }}</label>
                    <md-select v-model="options.update">
                        <md-option value="10 мин">10 мин</md-option>
                        <md-option value="Нет">Нет</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.interval') }}</label>
                    <md-select v-model="options.interval">

                        <md-option value="1">последний 1 час</md-option>
                        <md-option value="2">последний 2 часа</md-option>
                        <md-option value="3">последние 3 часа</md-option>
                        <md-option value="4">последние 4 часа</md-option>
                        <md-option value="5">последние 5 часов</md-option>
                        <md-option value="6">последние 6 часов</md-option>
                        <md-option value="7">последние 7 часов</md-option>
                        <md-option value="8">последние 8 часов</md-option>
                        <md-option value="9">последние 9 часов</md-option>
                        <md-option value="10">последние 10 часов</md-option>
                        <md-option value="11">последние 11 часов</md-option>
                        <md-option value="12">последние 12 часов</md-option>
                        <md-option value="today">сегодня</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.chanel') }}</label>
                    <md-select v-model="options.chanel">
                        <md-option value="SMS">{{$t('widget.channel.SMS')}}</md-option>
                        <md-option value="Call">{{$t('widget.channel.Call')}}</md-option>
                        <md-option value="Email">{{$t('widget.channel.Email')}}</md-option>
                        <md-option value="Push">{{$t('widget.channel.Push')}}</md-option>
                        <md-option value="Viber">{{$t('widget.channel.Viber')}}</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.service_provider') }}</label>
                    <md-select v-model="options.service_provider">
                        <md-option value="all">Все</md-option>
                        <md-option value="MTS">MTS</md-option>
                        <md-option value="Megafon">Megafon</md-option>
                    </md-select>
                </md-field>
            </widget-options>

        </template>
    </div>
</template>

<script>
  import widgetMixin from './mixin'
  import { DateTime,Settings } from 'luxon'

  export default {
    name: "TrafficProviders",
    mixins:[widgetMixin],
    props:{
      value:{},
      fullSize:{default:false}
    },
    data(){return{
      options:{
        update:'10 мин',
        interval:'1',
        chanel:'SMS',
        service_provider:'all',
      },
      ChartData: [10,20],
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} %"
        }
      }
    }},
    computed:{
      chartStyle(){
        if (this.fullSize){
          return {height: '60vh'}
        }
        return {height:'100%'}
      }
    },
    methods:{
      title(){
        const $t = this.$t.bind(this);
        let title = $t(`widget.TrafficProviders.title`)+' '+$t('widget.channel.'+this.options.chanel);

        let current = DateTime.local();
        switch (this.options.interval) {
          case 'today':
            title+=  ' сегодня';
            break;
          default:
            let start = DateTime.local().plus({hour:-this.options.interval});
            title+=  ' c '+start.toFormat('HH:ss');
            title+=  ' до '+current.toFormat('HH:ss');
            break;
        }

        return title;
      },
      randomInteger(min, max) {
        // случайное число от min до (max+1)
        let rand = min + Math.random() * (max + 1 - min);
        return Math.floor(rand);
      },

      demoData(min,max){
        max = max || 100;
        min = min || 1;
        let arr = [];
        for (let i = 0; i < 10; i++ ) {
          arr.push(this.randomInteger(min,max));
        }
        return arr
      },
      demoXAxis(){
        let arr = [];
        arr.push('MTS');
        arr.push('Beeline');
        arr.push('Megafon');

        return arr
      },
      demoSeries(){
        return [
          {
            type: 'bar',
            name: '',
            data: [80,50,97],
            stack: 'one',
            color: '#43b4e3',
          },
          {
            type: 'bar',
            name: '+',
            data: [10,0,9],
            stack: 'one',
            color: '#4caf50',
          },
          {
            type: 'bar',
            name: '-',
            data: [0,15,0],
            stack: 'one',
            color: '#f44336',
          },
        ]
      }
    },
    created() {
      Settings.defaultLocale = this.$i18n.locale;
    }
  }
</script>
